import { render, staticRenderFns } from "./OnuDetalhes.vue?vue&type=template&id=43aed626"
import script from "./OnuDetalhes.vue?vue&type=script&lang=js"
export * from "./OnuDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports